"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndicatorColor = exports.ActiveSpeakerIndicator = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _ActiveSpeakerIndicator = require("./ActiveSpeakerIndicator.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _environment = require("@studio/environment");
var IndicatorColor = exports.IndicatorColor = {
  WHITE: 'white',
  GREEN: 'green'
};

/**
 * ActiveSpeakerIndicator component displays an indicator for the active speaker.
 *
 * @component
 * @param {Object} props - The properties object.
 * @param {string} props.color - The color to determine which GIF to display.
 * @param {boolean} props.display - The display state of the indicator.
 * @returns {JSX.Element} The rendered ActiveSpeakerIndicator component.
 */

var ActiveSpeakerIndicator = exports.ActiveSpeakerIndicator = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _gifs;
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IndicatorColor.WHITE : _ref$color,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? true : _ref$display;
  var assetsBase = (0, _environment.getEnvVar)('REACT_APP_STATIC_ASSETS_BASE_URL');
  if (!assetsBase) {
    return null;
  }
  var gifs = (_gifs = {}, (0, _defineProperty2["default"])(_gifs, IndicatorColor.GREEN, "".concat(assetsBase, "active-speaker-green.gif")), (0, _defineProperty2["default"])(_gifs, IndicatorColor.WHITE, "".concat(assetsBase, "active-speaker-white.gif")), _gifs);
  var src = gifs[color];
  return /*#__PURE__*/_react["default"].createElement(_ActiveSpeakerIndicator.ImageWrapper, {
    "data-testid": "active-speaker-indicator"
  }, /*#__PURE__*/_react["default"].createElement(_ActiveSpeakerIndicator.StyledImage, {
    src: src,
    alt: "active-speaker-indicator",
    display: display
  }));
});
ActiveSpeakerIndicator.propTypes = {
  color: _propTypes["default"].oneOf([IndicatorColor.WHITE, IndicatorColor.GREEN]),
  display: _propTypes["default"].bool
};